import React from 'react';
import styled from 'styled-components';
import {
  Grid as SemanticGrid,
  Select as SemanticSelect,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  width: 100%;
  min-height: 100%;
`;

export const Select = styled(SemanticSelect)`
  margin-bottom: 1em;
  align-self: flex-start;
`;

export const Title = styled.h2``;

export const Grid = styled(SemanticGrid)`
 &&& {
    margin-bottom: 0px;
    margin-top: 0px;

    .row {
      padding: 5px 0px;
    }
  }
`;

export const Column = styled(SemanticGrid.Column)``;

export const Row = styled(SemanticGrid.Row)`
  &&& {
    word-wrap: break-word;
  }
`;

export const FieldName = styled(TextLayoutComponent.Bold)``;
export const FieldValue = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

const FullWidthContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  justify-content: center;
  align-items: center;
`;

export const Loader = () => (
  <FullWidthContainer>
    <LoaderLayoutComponent data-loader="screener-survey-loader" />
  </FullWidthContainer>
);
